import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Full-Stack Web Development",
      desc: "Expertise in developing full-stack web applications using modern frameworks and tools.",
      icon: "fas fa-code",
    },
    {
      name: "Database Design and Management",
      desc: "Proficient in designing and managing complex databases, ensuring data security and scalability.",
      icon: "fas fa-database",
    },
    {
      name: "Agile Project Management",
      desc: "Experience in leading software development teams and managing projects using Agile methodologies.",
      icon: "fas fa-tasks",
    },
    {
      name: "Quality Assurance and Testing",
      desc: "Skilled in creating test plans and executing comprehensive testing strategies to ensure high-quality software delivery.",
      icon: "fas fa-bug",
    },
    {
      name: "Technical Documentation",
      desc: "Proficient in creating technical documentation, including architecture diagrams, API documentation, and user manuals.",
      icon: "fas fa-file-alt",
    },
    {
      name: "Cloud Infrastructure Management",
      desc: "Experience in managing and deploying applications on cloud infrastructure such as AWS, Azure, and Google Cloud.",
      icon: "fas fa-cloud",
    },
    {
      name: "Cyber Security Consulting",
      desc: "Expertise in providing cyber security consulting services, including threat assessments, risk analysis, and security audits.",
      icon: "fas fa-shield-alt",
    },
    {
      name: "DevOps",
      desc: "Experience in DevOps practices such as continuous integration and delivery, automated testing, and infrastructure as code.",
      icon: "fas fa-cogs",
    },
  ];
  
  
  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
